import firebase from 'firebase/app';
import 'firebase/storage';
import { JoyTaskState } from 'joy-core';
export default class StorageUploadTask {
    constructor(task, completion, progressHandler) {
        this.task = task;
        this.completion = completion;
        this.progressHandler = progressHandler;
        this.lastState = JoyTaskState.suspended;
        this.lastProgress = 0;
        task.on('state_changed', (snapshot) => {
            this.lastProgress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            progressHandler(this.lastProgress);
            switch (snapshot.state) {
                case firebase.storage.TaskState.CANCELED:
                    this.lastState = JoyTaskState.canceled;
                    break;
                case firebase.storage.TaskState.ERROR:
                    this.lastState = JoyTaskState.completed;
                    break;
                case firebase.storage.TaskState.PAUSED:
                    this.lastState = JoyTaskState.suspended;
                    break;
                case firebase.storage.TaskState.RUNNING:
                    this.lastState = JoyTaskState.running;
                    break;
                case firebase.storage.TaskState.SUCCESS:
                    this.lastState = JoyTaskState.completed;
                    break;
                default:
                    break;
            }
        }, (error) => {
            completion(null, error);
        }, () => {
            task.snapshot.ref
                .getDownloadURL()
                .then((url) => {
                completion(url, null);
            })
                .catch((error) => {
                completion(null, Error('Failed to get download url from task.'));
            });
        });
    }
    state() {
        return this.lastState;
    }
    progress() {
        return this.lastProgress;
    }
    resume() {
        var _a;
        (_a = this.task) === null || _a === void 0 ? void 0 : _a.resume();
    }
    suspend() {
        var _a;
        (_a = this.task) === null || _a === void 0 ? void 0 : _a.pause();
    }
    cancel() {
        var _a;
        (_a = this.task) === null || _a === void 0 ? void 0 : _a.cancel();
    }
}
//# sourceMappingURL=StorageUploadTask.js.map